export const playerTier = {
  tier: "Tier",
  playerTier: "Player Tier",
  operatorTierConfig: "Operator Tier Config",
  name: "Name",
  addNewTier: "Add New Tier",
  createNewTier: "Create New Tier",
  minTurnover: "Min Turnover",
  maxTurnover: "Max TurnOver",
  rewardAmount: "Reward Amount",
  rewardType: "Reward Type",
  isActive: "Is Active",
  activate: "Activate",
  activated: "Activated",
  updateTier: "Update Tier",
  startDate: "Start Date",
  endDate: "End Date",
  duration: "Duration",
  activationStatus:'Activation Status',
  updateTierConfig:'Update Tier Config',
  cancel:'Cancel'
};
